var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m49.951 55.074-5.01-29.613c6.102-5.694 11.052-10.328 11.692-10.974 1.615-1.63 3.663-7.392 1.962-9.093s-7.47.34-9.093 1.962c-.97.97-5.498 5.8-10.993 11.689L8.915 14.038a1.64 1.64 0 0 0-1.431.457L5.52 16.458a.49.49 0 0 0 .116.781L28.74 29.53a19172 19172 0 0 0-11.33 12.19l-10.165.579a1.64 1.64 0 0 0-1.065.477l-1.31 1.311a.334.334 0 0 0 .115.556l10.265 3.494a.97.97 0 0 1 .604.604l3.515 10.287a.334.334 0 0 0 .556.115l1.312-1.31a1.64 1.64 0 0 0 .477-1.068l.566-10.197c2.874-2.673 7.367-6.854 12.174-11.33L46.75 58.352a.49.49 0 0 0 .781.117l1.963-1.964a1.64 1.64 0 0 0 .457-1.431",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPlane);
export default __webpack_public_path__ + "static/media/new-plane.bde754937a8525d8cb6a4d2b4bb60d3d.svg";
export { ForwardRef as ReactComponent };